module.exports = __webpack_public_path__ + "img/xls.958e7219.png";